/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import { keynoteSpeakersSlider } from './modules/keynoteSpeakersSlider';
import { homeHeroSlider } from './modules/homeHeroSlider';
import { popup } from './modules/popup';
import { getUpdates } from './modules/getUpdates';
import { mobileNav } from './modules/mobileNav';

mobileNav();
var homeHeroSliderExists = document.querySelector('.hero__slider');
if (homeHeroSliderExists) {
  homeHeroSlider();
}


imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
  // Load stuff after all the images in the body load
  var keynoteSpeakersSliderExists = document.querySelector('.keynoteSpeakers__slider');
  if (keynoteSpeakersSliderExists) {
    keynoteSpeakersSlider();
  }

  var imageGalleryExists = document.querySelector('.agcEvent__galleryImages');
  if (imageGalleryExists) {
    popup();
  }
});

getUpdates();
